import { Dialog, DialogProps } from "@mui/material";

import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";

import AppModalTitle from "../../Modals/AppModalTitle";
import { DamageDetectionItemView, DamageDetectionItemViewProps } from "./DamageDetectionItemView";

export interface OwnProps {
  viewProps: DamageDetectionItemViewProps;
}
type Props = OwnProps & DialogProps;

export function DamageDetectionItemViewModal({ viewProps, ...dialogProps }: Props) {
  const openStatus = useModalOpenStatus(dialogProps);

  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalTitle
        withClose
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        Item {viewProps.item.localNumber ? `#${viewProps.item.localNumber}` : ""}
      </AppModalTitle>
      <AppModalContent>
        {openStatus.isOpen && (
          <DamageDetectionItemView
            {...viewProps}
            // displayProps={{ viewVariant: ViewLayoutVariant.Modal, ...viewProps?.displayProps }}
          />
        )}
      </AppModalContent>
    </Dialog>
  );
}
